import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../lib/supabase';
import { Save, CheckCircle } from 'lucide-react';

const LANGS = ['pt-BR', 'en', 'it'];

const SettingsAdmin = () => {
  const [contactInfo, setContactInfo] = useState({ email: '', phone: '', linkedin: '', location: {} });
  const [saved, setSaved] = useState(false);

  const fetch = useCallback(async () => {
    const { data } = await supabase.from('site_settings').select('*').eq('key', 'contact_info').single();
    if (data) setContactInfo(data.value);
  }, []);
  useEffect(() => { fetch(); }, [fetch]);

  const save = async () => {
    const { data } = await supabase.from('site_settings').select('id').eq('key', 'contact_info').single();
    if (data) {
      await supabase.from('site_settings').update({ value: contactInfo }).eq('key', 'contact_info');
    } else {
      await supabase.from('site_settings').insert({ key: 'contact_info', value: contactInfo });
    }
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-6">Configurações</h1>
      <div className="bg-gray-900 border border-gray-800 rounded-2xl p-6 space-y-6 max-w-xl">
        <h2 className="text-base font-bold text-lime-400 uppercase">Informações de Contato</h2>
        <div>
          <label className="block text-gray-300 text-xs font-semibold uppercase mb-2">Email</label>
          <input value={contactInfo.email} onChange={e => setContactInfo({...contactInfo, email: e.target.value})}
            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-lime-400" />
        </div>
        <div>
          <label className="block text-gray-300 text-xs font-semibold uppercase mb-2">Telefone</label>
          <input value={contactInfo.phone} onChange={e => setContactInfo({...contactInfo, phone: e.target.value})}
            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-lime-400" />
        </div>
        <div>
          <label className="block text-gray-300 text-xs font-semibold uppercase mb-2">LinkedIn URL</label>
          <input value={contactInfo.linkedin} onChange={e => setContactInfo({...contactInfo, linkedin: e.target.value})}
            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-lime-400" />
        </div>
        <div className="space-y-2">
          <label className="block text-gray-300 text-xs font-semibold uppercase tracking-wide">Localização</label>
          {LANGS.map(lang => (
            <div key={lang} className="flex items-center space-x-2">
              <span className="text-gray-500 text-xs w-10">{lang}</span>
              <input value={(contactInfo.location && contactInfo.location[lang]) || ''} onChange={e => setContactInfo({...contactInfo, location: { ...contactInfo.location, [lang]: e.target.value }})}
                className="flex-1 px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-lime-400" />
            </div>
          ))}
        </div>
        {saved && <div className="flex items-center space-x-2 text-green-400"><CheckCircle size={16} /><span className="text-sm">Salvo com sucesso!</span></div>}
        <button onClick={save} className="px-8 py-3 bg-lime-400 text-black font-bold rounded-full hover:bg-lime-300 flex items-center space-x-2">
          <Save size={18} /><span>Salvar</span>
        </button>
      </div>
    </div>
  );
};

export default SettingsAdmin;
